module.exports = __webpack_public_path__ + "static/media/calefont16.3eaea56e.png";